<dac-navbar [doubleNav]="false"></dac-navbar>
<div class="container pt-5 pb-5">
  <div class="row">
    <div class="col">
      <h1 class='text-center'>Privacy Policy</h1>
      <p style="font-weight:bold; font-size:17px;" class="sans">Thank you for visiting our Web site. This privacy policy
        tells you how we use personal information collected at this site and describes how we protect your personal
        information. Please read this privacy policy before using the site or submitting any personal information.</p>

      <p style="font-size:17px; color:#1969a1;">By using the site, you are accepting the practices described in this
        privacy policy. These practices may be changed, but any changes will be posted and changes will only apply to
        activities and information on a going forward, not retroactive basis. You are encouraged to review the privacy
        policy whenever you visit the site to make sure that you understand how any personal information you provide
        will be used.</p>

      <h3>Registered Clinicians</h3>
      <p>This privacy policy does not apply to the personal information we may collect about your patients, customers and clients in the context
        of providing services to you.  Our treatment of Client Personal information is governed by our Terms of Service and HIPAA Business Associates
        Agreement.  If any provision in our Agreement conflicts with any provision in the Privacy Policy, the provision of the Agreement will control
        to the extent of any such conflict. 

        If we receive any requests from your clients about Personal Health Information, we will direct those inquiries or requests to you.
      </p>

      <h3>Collection of Information</h3>
      <p>Discover and Change collects personally identifiable information, login/password, your name, email
        address, etc., when voluntarily submitted by our visitors. The information you provide is used to fulfill your
        specific request. If you supply your postal address/telephone number, you may receive periodic mailings/calls
        from us with information on new products and services or upcoming events. If you do not wish to receive such
        mailings/calls, please inform us via the e-mail address shown below.</p>

      <h3>Cookie / Tracking Technology</h3>
      <p>The Web site may use cookie and tracking technology depending on the features offered. Cookie and tracking
        technology are useful for gathering information such as browser type and operating system, tracking the number
        of visitors to the Web site, and understanding how visitors use the Web site. Cookies can also help customize
        the Web site for visitors. Personal information is not collected via cookies or other tracking technology.
        However, if you previously provided personally identifiable information, cookies may be tied to such
        information.

        <h3>Commitment to Data Security</h3>
        <p>Your personally identifiable information is kept secure. Only your clinician and you have access to your
          secure information. In the case of contacting our office for support, you will be asked for your permission to
          access your personal file. We are committed to maintaining your confidentiality. You will be accountable for
          providing anyone else your personal login/password.</p>

        <h3>HIPPA Security</h3>
        <p>Discover and Change has a comprehensive approach to ensuring that it meets the requirements of HIPAA. Each
          clinician is given their own password and identity, that enables him or her to access or
          act upon only the information that he or she is allowed to access. 
          All Personal Health Information is encrypted both in transit from your device and to our servers.  All information
          stored is encrypted on our services.  All employees undergo training on best practices and utilizing PHI on a need to know only basis.
          All access to personal health information is regularly monitored and audited to make sure we are fulfilling security best practices
          and ensuring the safety and integrity of your data.
          
          Discover and Change is committed to being HIPAA compliant.

          <h3>Privacy Contact Information</h3>
          <p style="padding-bottom:14px;">If you have any questions, concerns, or comments about our privacy policy you
            may contact our HIPAA compliance officer using the information below:</p>

          <p style="margin:10px 0 10px 52px; line-height:22px;">
            <strong>By e-mail:</strong><br />
            <a href="mailto:compliance@discoverandchange.com">compliance@discoverandchange.com</a>
          </p>
          <p style="font-size:12px; text-align:right;">* We reserve the right to make changes to this policy. Any
            changes to this policy will be posted.</p>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/privacy/privacy.component.html